import { render, staticRenderFns } from "./HomeBestsellers.vue?vue&type=template&id=5e344a90&scoped=true&"
import script from "./HomeBestsellers.vue?vue&type=script&lang=js&"
export * from "./HomeBestsellers.vue?vue&type=script&lang=js&"
import style0 from "./HomeBestsellers.vue?vue&type=style&index=0&id=5e344a90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e344a90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BestsellerCard: require('/var/www/app/components/BestsellerCard.vue').default})
